import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BudgetTableContainer } from 'pages/calculator/MediaPlanning/common/BudgetTable/styles';
import BudgetTableRow from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/BudgetTableRow/BudgetTableRow';
import {
  OfflineBudgetTableRowData,
  TableHeader,
} from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import calculateOfflineTotalBudgetRowData from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/calculateOfflineTotalBudgetRowData';

interface OfflineBudgetTableProps {
  data: OfflineBudgetTableRowData[];
}

function OfflineBudgetTable({ data }: OfflineBudgetTableProps) {
  const { t } = useTranslation();

  const tableHeaders: TableHeader[] = [
    { key: 'mediaPlanning.touchpoint', align: 'left', width: '200px' },
    { key: '', align: 'right' },
    { key: 'mediaPlanning.tvReachOne', align: 'right' },
    { key: 'mediaPlanning.tvReachThree', align: 'right' },
    { key: 'mediaPlanning.grp', align: 'right' },
    { key: 'mediaPlanning.weeks', align: 'right' },
    { key: 'mediaPlanning.budget', align: 'right' },
  ];

  if (!data.length) {
    return null;
  }

  return (
    <Grid container sx={{ px: '15px' }}>
      <Grid item xs={12}>
        <Typography
          textTransform="uppercase"
          fontWeight={700}
          sx={{ pb: '12px' }}
        >
          {t('mediaPlanning.offlineBudget')}
        </Typography>
        <BudgetTableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '34px' }} />
                {tableHeaders.map((header) => (
                  <TableCell
                    key={header.key}
                    align={header.align}
                    sx={{ width: header?.width || 'auto' }}
                  >
                    <Typography
                      variant="caption"
                      textTransform="uppercase"
                      fontWeight={600}
                    >
                      {t(header.key)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(
                (row) =>
                  row.touchpoint !== 'tech cost' && (
                    <BudgetTableRow key={row.id} rowData={row} />
                  )
              )}
              <BudgetTableRow
                rowData={calculateOfflineTotalBudgetRowData(data)}
                sx={{ backgroundColor: 'tableBackground.main' }}
              />
            </TableBody>
          </Table>
        </BudgetTableContainer>
      </Grid>
    </Grid>
  );
}

export default OfflineBudgetTable;
